import { render } from "./userInserats.vue?vue&type=template&id=391918ca&scoped=true"
import script from "./userInserats.vue?vue&type=script&lang=ts"
export * from "./userInserats.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-391918ca"

export default script